import { createSlice } from "@reduxjs/toolkit";
import { addQuizForTopicId } from "../topics/topicsSlice";

const quizzesSliceOptions = {
     name:'quizzes',
     initialState:{
        quizzes:{
            // '456': {
            //     id: '456',
            //     topicId: '222',
            //     name: 'quiz for example topic',
            //     cardIds: ['789', '101', '102']
            //   }
        }
     },
        reducers:{
         addQuiz: (state, action) => {
            const { id } = action.payload;
            state.quizzes[id] = action.payload;
          } 
           
      }
};
   
export const addQuizForTopic = (quiz) =>{
   const { topicId, id } = quiz;
   return (dispatch) => {
      dispatch(quizzesSlice.actions.addQuiz(quiz)); 
      dispatch(addQuizForTopicId({ quizId:id , topicId:topicId }));
        
    }
}







export const quizzesSlice = createSlice(quizzesSliceOptions);
export const selectQuizzes = (state) => state.quizzes.quizzes;
export const { addQuiz } = quizzesSlice.actions;
export default quizzesSlice.reducer;
